import { useCallback } from "react"
import { useFetcher } from "react-router"
import type { ActionResponse } from "@/utils/types"
import type { LoaderData } from "./brand-ui-config"
import { SharedFeaturesTab, type FeaturesConfig } from "../shared/SharedFeaturesTab"

export function FeaturesTab({ config, data }: { config: FeaturesConfig | undefined; data: LoaderData }) {
  const fetcher = useFetcher<ActionResponse>()
  const pendingAction = fetcher.formData?.get("action") as "SAVE_SECTION" | "REMOVE_SECTION" | null

  const handleSave = useCallback(
    (newFeatureStates: FeaturesConfig) => {
      const formData = new FormData()
      formData.append("action", "SAVE_SECTION")
      formData.append("organisation", data.loadedOrganisation)
      formData.append("brand", data.loadedBrand ?? "")
      formData.append("jsonPath", "$.features")
      formData.append("value", JSON.stringify(newFeatureStates))
      formData.append("concurrency", data.config?.concurrency ?? "")

      fetcher.submit(formData, { method: "post" })
    },
    [fetcher, data],
  )

  const handleRemove = useCallback(() => {
    const formData = new FormData()
    formData.append("action", "REMOVE_SECTION")
    formData.append("organisation", data.loadedOrganisation)
    formData.append("brand", data.loadedBrand ?? "")
    formData.append("jsonPath", "$.features")
    formData.append("concurrency", data.config?.concurrency ?? "")

    fetcher.submit(formData, { method: "post" })
  }, [fetcher, data])

  return (
    <SharedFeaturesTab
      config={config}
      onSave={handleSave}
      onRemove={handleRemove}
      isFetching={fetcher.state !== "idle"}
      currentAction={pendingAction}
    />
  )
}
